// ===============================  出價選擇  ===============================
export enum BidMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
  NULL = 'null',
}

// ===============================  自動出價策略  ===============================
export enum RoasStrategy {
  HIGH_ROAS = 'HIGH_ROAS',
  MEDIUM_ROAS = 'MEDIUM_ROAS',
  LOW_ROAS = 'LOW_ROAS',
  CUSTOM_ROAS = 'CUSTOM_ROAS',
}

// ===============================  手動關鍵字  ===============================
export enum ManualKeywordProperty {
  ID = 'id',
  KEYWORD = 'keyword',
  PRICE = 'price',
  SUGGEST_PRICE = 'suggestPrice',
}

export interface ManualKeywordType {
  [ManualKeywordProperty.ID]: number | undefined;
  [ManualKeywordProperty.KEYWORD]: string;
  [ManualKeywordProperty.PRICE]: number;
}

export interface ManualKeywordWithSuggestType extends ManualKeywordType {
  [ManualKeywordProperty.SUGGEST_PRICE]: number;
}

export const MANUAL_UNIQUE_KEY = ManualKeywordProperty.KEYWORD;

// ===============================  推薦關鍵字  ===============================
export enum SuggestKeywordProperty {
  SUGGEST_KEYWORD = 'suggestKeyword',
  CPC = 'cpc',
  PR = 'pr',
  STAR = 'star',
}

export interface SuggestKeywordType {
  [SuggestKeywordProperty.SUGGEST_KEYWORD]: string;
  [SuggestKeywordProperty.CPC]: string;
  [SuggestKeywordProperty.PR]: string;
  [SuggestKeywordProperty.STAR]: number;
}

export const SUGGEST_KEYWORD_UNIQUE_KEY =
  SuggestKeywordProperty.SUGGEST_KEYWORD;
